import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { VolumeStack } from './VolumeStack';

/** Paste the live checkout URL here (platform not defined yet). */
const CHECKOUT_URL = '';
const included = ['6 volumes · 90 three-way activities', '5 instant-use bonuses', '300 landscape pages, print or phone', '15, 30 and 45-minute sessions + a 10-minute 1:1 visit', '48 planning worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-188" data-mp="1ru9hi3oa51ly">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-189" data-mp="20t4ovj328hqu">
        <div className="text-center" data-id="element-190" data-mp="20rjvhwshf4uk">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-191" data-mp="3h7ec29vkg0g3">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-192" data-mp="3c78i2n1tq1uu">
            Everything you need to run{' '}
            <span className="italic" data-id="element-193" data-mp="4scnz1ws1usk">every activity three ways</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-194" data-mp="9rp6jagm8fpc">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-195" data-mp="erlgdqbzv1ct">
            <h3 className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-196" data-mp="eoz6hk1ms9rf">
              Memory Care Activity Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-197" data-mp="3i8tuq07ijj2s">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-198" data-mp="3rxv8djql5odl">
            <div className="mx-auto max-w-lg rounded-2xl bg-plum" data-id="element-199" data-mp="3rywwaospa5cq">
              <VolumeStack data-id="element-200" data-mp="2uipqprqexhb9" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-201" data-mp="2uhobrc6a0ao9">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-202" data-mp="2zfzqa07in9ct">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/25" data-id="element-203" data-mp="2rftcca3hjhf4">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-204" data-mp="2mhi3o2oxfcyh" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-205" data-mp="28hh36ockq7jj">
              <div className="flex items-start justify-center gap-1 text-plum" data-id="element-206" data-mp="23ixhmp1w6xrp">
                <span className="mt-2.5 font-display text-3xl" data-id="element-207" data-mp="23l0cbmdzpf2r">$</span>
                <span className="font-display font-bold text-6xl leading-[0.9] sm:text-7xl" data-id="element-208" data-mp="2ihrgsa2itgz8">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-209" data-mp="2djg3tqgxiqcs">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-210" data-mp="3ov7ae3yzpbxe">
                <span className="rounded-full border border-gold bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-211" data-mp="9udy4r1spjr">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-212" data-mp="3nfl9oa1bzgdv">
                  No subscription
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-213" data-mp="j0lk6xfqnztx">
                  Instant download
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL || '#pricing'} className="mt-5" data-id="element-214" data-mp="a81redm4oph0">
                Get Memory Care Activity Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-soft" data-id="element-215" data-mp="11z7jc6rp3gv7">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-216" data-mp="16r928bjdc5u7">
                <li className="flex items-center gap-1.5" data-id="element-217" data-mp="3f8tp49uor8g7">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-218" data-mp="3a85vrhizifit" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-219" data-mp="318ix33hn3ntg">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-220" data-mp="31a3rmt3yf6rb" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-221" data-mp="3t19lirt30885">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-222" data-mp="3o6vu10hjil8r" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-soft" data-id="element-223" data-mp="frvc2zc0ksyr">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}